// SPDX-License-Identifier: MIT
// Read the current user's payment history from `public.payments`. RLS
// (select_own_payments) scopes the rows to the signed-in user; the webhook
// (service_role) is the only writer. Returns [] when not authenticated or on error.
import { supabase } from '../auth/supabase';

export interface Payment {
  id: string; // mollie_payment_id
  sku: string;
  amountEur: string; // Mollie value string, e.g. "10.00"
  status: string; // "paid"
  createdAt: string; // ISO timestamp
}

export async function listPayments(): Promise<Payment[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];
  const { data, error } = await supabase
    .from('payments')
    .select('mollie_payment_id,sku,amount_eur,status,created_at')
    .order('created_at', { ascending: false });
  if (error) {
    console.warn('[billing] listPayments failed', error);
    return [];
  }
  return (data ?? []).map((r) => ({
    id: r.mollie_payment_id as string,
    sku: r.sku as string,
    amountEur: r.amount_eur as string,
    status: r.status as string,
    createdAt: r.created_at as string,
  }));
}
